export class ProdutoModel {
  id: number;
  nome: string;
  produto_tipo_ref: number;
}